import React, { useState, useEffect, useRef } from "react";
import footbal from "../../../assets/customerAssets/football.png";
import { Box, Button, IconButton, ImageListItem } from "@mui/material";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import cameraIcon from "../../../assets/customerAssets/icons/camera.svg";
import { supportedVideoFileTypes } from "../../../helper/commonFunctions";
import { toast, ToastContainer } from "react-toastify";
import ClearIcon from "@mui/icons-material/Clear";

const BannerImage = ({ formik, edited }) => {
  //   const [img, setImg] = useState(null);
  // const [imgPreview, setImgPreview] = useState(() =>
  //   edited
  //     ? formik.values.image
  //     : formik.values.image
  //     ? URL.createObjectURL(formik.values.image)
  //     : null
  // );
  const [imgPreview, setImgPreview] = useState(null);
  const imageInputRef = useRef(null);

  useEffect(() => {
    if (typeof formik.values.YTVideo === "string") {
      setImgPreview(formik.values.YTVideo);
    } else if (formik.values.YTVideo instanceof File) {
      setImgPreview(URL.createObjectURL(formik.values.YTVideo));
    } else {
      setImgPreview(null);
    }
  }, [formik.values.YTVideo]);

  const handleChange = (e) => {
    const file = e.target.files[0];
    if (!file) {
      toast.error("Please select a file");
      return;
    }
    const fileType = file.type.split("/")[1];
    const fileExt = file.name.split(".").pop().toLowerCase();

    if (
      supportedVideoFileTypes.includes(file.type) === false &&
      supportedVideoFileTypes.includes(fileExt) === false
    ) {
      toast.error("Please select a valid image file");
      return;
    }

    // setImg(URL.createObjectURL(file));
    // setImgPreview(URL.createObjectURL(file));
    formik.setFieldValue("YTVideo", file);
  };

  // "";

  return (
    <>
      <ToastContainer />
      <Box className="preview-wrapper">
        <input
          type="file"
          name="YTVideo"
          onChange={handleChange}
          style={{ display: "none" }}
          ref={imageInputRef}
        />
        <Box className="preview" sx={{ padding: "0" }}>
          {imgPreview ? (
            <video
              src={imgPreview}
              alt="football"
              className="img_fluid"
              controls
              muted
              style={imgPreview ? { objectFit: "cover" } : { opacity: "24%" }}
            />
          ) : (
            <Button
              className="upload_button"
              onClick={() =>
                imageInputRef.current && imageInputRef.current.click()
              }
            >
              + Upload
            </Button>
          )}
        </Box>
        {imgPreview && (
          <IconButton
            onClick={() => {
              setImgPreview("");
              formik.setFieldValue("YTVideo", "");
            }}
            className="clear-Icon"
          >
            <ClearIcon
              sx={{
                fontSize: "30px",
              }}
              className="clear-preview-img"
            />
          </IconButton>
        )}
      </Box>
    </>
  );
};

export default BannerImage;
